export default __webpack_public_path__ + "static/join-7fe3347ed97e528185bc5141bc651d10.jpg";